var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVimeo = function SvgVimeo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 230.8 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M230.7 46.3q-1.5 33.75-47.1 92.4C152.2 179.6 125.7 200 104 200c-13.4 0-24.8-12.4-34.1-37.3L51.3 94.3c-7-24.9-14.4-37.4-22.3-37.4-1.7 0-7.8 3.6-18.1 10.9L0 53.8c11.4-10 22.6-20.1 33.7-30.1C48.9 10.6 60.3 3.6 67.9 2.9c18-1.7 29 10.6 33.2 36.9 4.5 28.4 7.6 46.1 9.3 53 5.2 23.6 10.9 35.3 17.1 35.3 4.8 0 12.1-7.6 21.8-22.9s14.8-26.9 15.5-34.9c1.4-13.2-3.8-19.8-15.5-19.8-5.5 0-11.2 1.3-17.1 3.8 11.3-37.2 33-55.3 65-54.3 23.6.7 34.8 16.1 33.5 46.3"
  })));
};
export default SvgVimeo;